// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"580":"7f86c97f","971":"74deaef0"}[chunkId] + ".chunk.css";
};